import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Provider } from 'react-redux';
import {store} from './app/Store'
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
<Provider store={store}>
<GoogleOAuthProvider clientId="130810143737-froo1vpum4pdbkqk4p9m719dgtph31dl.apps.googleusercontent.com">
    <App />
</GoogleOAuthProvider>
</Provider>
  </React.StrictMode>
);
